import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ApiCodedError, ApiError401 } from "./lib/api";
import RouteError from "./pages/RouteError";
import { routeTree } from "./routeTree.gen";
import "./index.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Retry once, except when the server refused the caller: retrying a
			// login, purchase or rate-limit refusal only delays the explanation.
			retry: (failures, error) =>
				failures < 1 &&
				!(error instanceof ApiError401) &&
				!(error instanceof ApiCodedError && (error.code === "year_access_required" || error.code === "rate_limited")),
			refetchOnWindowFocus: false,
		},
	},
});

const router = createRouter({
	routeTree,
	context: { queryClient },
	defaultPreload: "intent",
	defaultErrorComponent: RouteError,
	scrollRestoration: true,
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Root element "#root" not found in index.html');

createRoot(rootElement).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</StrictMode>,
);
